<template>
    <div class="container py-5 confirm_order_page" style="min-height:600px">
        <div v-if="loading">
            <hollow-dots-spinner class="loading_card_spinner" :animation-duration="1000" :dot-size="35" :dots-num="3"
                color="var(--primary-color)" />

        </div>
        <div v-else class="row g-4 confirm_page">
            <!-- Left Side -->
            <div class="col-lg-7 col-md-12 confirm_product_div">
                <!-- Contact -->
                <div class=" mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="mb-0">{{ $t('Contact') }}</h5>
                        <a @click="$router.push({
                            name: 'login',
                            params: {
                                storeName: $store.storeName,
                                lang: $i18n.locale
                            },
                        });" style="color: black; text-decoration: underline;
                                    font-size: 14px;cursor:pointer">{{ $t('logIn') }}</a>
                    </div>
                    <div class="mb-3">
                        <span class="flag_account">{{ $store.state.country_code }}</span>

                        <input type="text" class="form-control input_text" autocomplete="" v-model="phone" required
                            :minlength=$store.state.country_length :maxlength=$store.state.country_length id="phone"
                            style="text-align:center">
                    </div>
                    <div v-if="this.$store.state.auth == 1" class="form-check mb-3">
                        <input class="form-check-input " type="checkbox" @change="funcreate_account_email"
                            id="account_email">
                        <label class="form-check-label" for="offers">{{ $t('create account') }}</label>
                    </div>
                    <div class="mb-3">
                        <input type="text" class="form-control input_text" id="name" autocomplete="false"
                            v-model="user_name" required maxlength="255" minlength="3" :placeholder="$t('name')">
                    </div>

                    <div class="mb-3">
                        <input type="email" class="form-control input_text" :placeholder="$t('email')"
                            autocomplete="false" v-model="email" required id="email">

                    </div>
                    <div v-if="this.$store.state.auth == 0" class="form-check mb-3">
                        <input class="form-check-input" type="checkbox" @change="funcreate_account_email"
                            id="account_email">
                        <label class="form-check-label" for="offers">{{ $t('create account') }}</label>
                    </div>
                </div>
                <!-- start delivery -->
                <div class="mb-4">
                    <h5 class="mb-3" id="delivery">{{ $t('Shipping Method') }}</h5>


                    <!-- Online Payment full block -->
                    <div class="rounded mb-0" style="border: 0.5px solid #c6bdbd; background-color: #fcfef1;">
                        <!-- Radio and title -->
                        <div :id="'delivery_method' + item.id" :class="'delivery_items delivery' + item.id"
                            v-for="(item, index) in this.DBitems.delivery_type.types" :key="index">
                            <label :for="'delivery' + item.id"
                                class="form-check-label w-100 p-3 d-flex align-items-center justify-content-between"
                                style="cursor:pointer;">
                                <div class="d-flex align-items-center">
                                    <input class="form-check-input me-3" type="radio" name="paymentMethod"
                                        :id="'delivery' + item.id" :value="item.id"
                                        @click="selectDeliveryTypeId(item.id)">
                                    <span class="fw-bold mb-0 text-dark">{{ item.type }}</span>
                                </div>

                            </label>
                        </div>

                        <!-- address -->
                        <div v-if="showAddress" class="m-4">
                            <div class="mb-3">
                                <v-select v-model="country" :reduce="(option) => option.id" :options="countries"
                                    label="city" :placeholder="$t('country')" class="form-select form-input mt-2 
          w-full py-2 px-3 h-10 bg-transparent 
          dark:bg-slate-900 dark:text-slate-200 
          rounded outline-none border border-gray-100 
          dark:border-gray-800 focus:ring-0 address_input " id="country">
                                </v-select>
                            </div>
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-lg-6"> <v-select v-model="city" :reduce="(option) => option.id"
                                            :options="cities" label="city" :placeholder="$t('city')" class="form-select form-input mt-2 
          w-full py-2 px-3 h-10 bg-transparent 
          dark:bg-slate-900 dark:text-slate-200 
          rounded outline-none border border-gray-100 
          dark:border-gray-800 focus:ring-0 address_input " id="city">
                                        </v-select></div>
                                    <div class="col-lg-6">
                                        <v-select v-model="region" :reduce="(option) => option.id" :options="regions"
                                            label="city" :placeholder="$t('region')" class="form-select form-input mt-2 
          w-full py-2 px-3 h-10 bg-transparent 
          dark:bg-slate-900 dark:text-slate-200 
          rounded outline-none border border-gray-100 
          dark:border-gray-800 focus:ring-0 address_input" id="region">
                                        </v-select>
                                    </div>

                                </div>
                            </div>




                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <input type="text" class="form-control address_text" autocomplete="false"
                                            required :placeholder="$t('street')" maxlength="255" id="street"
                                            v-model="street">
                                    </div>

                                    <div class="col-lg-6">
                                        <input type="text" class="form-control address_text" autocomplete="false"
                                            :placeholder="$t('building')" maxlength="255" v-model="building"
                                            id="building">
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <input type="text" :placeholder='$t("OtherDetails")' class="form-control address_text"
                                    v-model="other_details">
                            </div>
                        </div>
                        <!-- end delivery  -->



                        <!-- end address -->

                    </div>
                    <div class="mb-3 mt-4">
                        <label for="couponCode" class="form-label">
                            {{ $t('Do you have a coupon?') }}</label>
                        <div class="input-group">
                            <input type="text" id="couponCode" class="form-control coupon_text" v-model="disCode"
                                :placeholder="$t('Couponcode')">
                            <button class="btn btn-dark" type="button" @click="Couponcode()">
                                        <i class="fa fa-spinner fa-spin " v-if="loading_coupon" style="color:white"></i>

                                {{ $t("Activate")
                            }}</button>
                        </div>
                        <small id="couponMessage" class="text-success mt-2 d-block"
                            v-if="couponMsg != '' || couponMsg != null">{{ couponMsg }}</small>
                    </div>

                </div>

                <!-- Delivery -->




                <!-- Shipping -->
                <div v-if="selectDeliveryType==5" class=" mb-4">
                    <h5>{{ $t('DeliveryMethod') }}</h5>
                    <div class="border p-3 rounded d-flex justify-content-between">
                        <span>{{ $t('Shipping charges apply upon delivery.') }}</span>
                        <span v-if="deliveryPrice == 0">{{ $t('free') }}</span>
                        <span v-else>{{ (deliveryPrice * this.$store.state.rate).toFixed($store.state.digit_price)
                        }}
                            {{ $store.state.UnitPrice }}</span>
                    </div>
                </div>
                <!-- end delivery -->

                <div class="mb-4">
                    <h5 class="mb-3" id="payment">{{ $t('Payment Method') }}</h5>
                    <p class="text-muted mb-4">{{ $t('All transactions are secure and encrypted.') }}</p>

                    <!-- start payment -->
                    <!-- Online Payment full block -->
                     <div class="rounded">
                    <div v-for="(item, index) in this.DBitems.payment_types.types" :key="index">
                        <div v-if="item.id == 2" id="onlineBlock" class="mb-0"
                            style="border: 1px solid #000; background-color: #f5f5f5;">
                            <!-- Radio and title -->
                            <label for="onlinePayment"
                                class="form-check-label w-100 p-3 d-flex align-items-center justify-content-between"
                                style="cursor:pointer;">
                                <div class="d-flex align-items-center">
                                    <input class="form-check-input me-3" type="radio" name="paymentMethod"
                                        id="onlinePayment" @click="selectPaymentTypeId(item.id)">
                                    <span class="fw-bold mb-0 text-dark">{{ item.type }}</span>
                                </div>
                                <div>
                                    <img src="/theme15/assest/images/visa.sxIq5Dot.svg" alt="Visa" width="40"
                                        class="me-2">
                                    <img src="/theme15/assest/images/master.CzeoQWmc.svg" alt="MasterCard" width="40">
                                </div>
                            </label>

                            <!-- Description -->
                            <div id="onlineSection" class="p-4 border-top" style="border-color: #000;">
                                <div class="text-center">
                                    <!-- <img src="browser-icon.png" alt="Payment" width="100" class="mb-3"> -->
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-252.3 356.1 163 80.9"
                                        style="width: 155px; margin-bottom:20px" class="zjrzY">
                                        <path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2"
                                            d="M-108.9 404.1v30c0 1.1-.9 2-2 2H-231c-1.1 0-2-.9-2-2v-75c0-1.1.9-2 2-2h120.1c1.1 0 2 .9 2 2v37m-124.1-29h124.1">
                                        </path>
                                        <circle cx="-227.8" cy="361.9" r="1.8" fill="currentColor"></circle>
                                        <circle cx="-222.2" cy="361.9" r="1.8" fill="currentColor"></circle>
                                        <circle cx="-216.6" cy="361.9" r="1.8" fill="currentColor"></circle>
                                        <path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2"
                                            d="M-128.7 400.1H-92m-3.6-4.1 4 4.1-4 4.1"></path>
                                    </svg>
                                    <p class="small text-muted mb-0">
                                        {{ $t('After clicking “Pay now”, you will be redirected to Online') }}<br>
                                        {{ $t('Payment to complete your purchase securely.') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Cash on Delivery full block -->
                        <div v-else id="codBlock" 
                            style="border: 1px solid #000; background-color: #fff;">
                            <label for="codPayment"
                                class="form-check-label w-100 p-3 d-flex align-items-center justify-content-between"
                                style="cursor:pointer;">
                                <div class="d-flex align-items-center">
                                    <input class="form-check-input me-3" type="radio" name="paymentMethod"
                                        id="codPayment" :value="item.id" @click="selectPaymentTypeId(item.id)">
                                    <span class="fw-bold mb-0 text-dark">{{ item.type }}</span>
                                </div>
                            </label>

                            <div id="codSection" class="p-4 border-top" style="border-color: #000; display:none;">
                                <p class="small text-muted mb-0 text-center">{{ item.type }}</p>
                            </div>
                        </div>

                    </div>
                    </div>
                    <!-- end payment -->
                </div>

                <!-- Billing Address -->

                <!-- Pay Button -->
                <button id="confirm_btn" @click="confirmOrder()" class="btn  w-100 py-3"
                    style="background-color: rgb(0, 0, 0); color: white;">
                    <i class="fa fa-spinner fa-spin " v-if="loading_confirm" style="color:white"></i>
                    {{ $t("confirmOrder") }}</button>

                <p class="mt-3"><a href="#" class="text-muted text-decoration-none">Privacy policy</a></p>
            </div>

            <!-- Right Side Summary -->
            <div class="col-lg-5 col-md-12">

    

                    <!-- Header -->
                    <div class="header-container d-flex justify-content-between mb-3">
                        <div class="logo">
                            <img :src="this.$store.state.logo" class="confirm_logo">
                        </div>
                        <div class="cart-icon" @click="$router.push({
                            name: 'shoppingCart',
                            params: {
                                storeName: $store.storeName,
                                lang: $i18n.locale
                            },
                        });">
                            <i class="bi bi-bag"></i>
                        </div>
                    </div>
                    <div class="order_summery">
                    <div class="d-flex justify-content-between">
                    <h5 class="title_confirm">{{ $t('order summery') }}</h5>
                    <h5>   {{ (totalPrice * this.$store.state.rate).toFixed($store.state.digit_price) }} {{
                                this.$store.state.UnitPrice }}</h5>
                </div>
                </div>

                    <item_cart v-for="item in this.items" :key="item" :item-id="item"></item_cart>

                    <!-- Summary -->

                    <div class="d-flex justify-content-between mb-2">
                        <span class="summary-label">{{ $t('subTotal') }} · {{ this.$store.state.cartCounter }} {{
                            $t('items') }}</span>
                        <span class="summary-label">
                            {{ (PartialPrice * this.$store.state.rate).toFixed($store.state.digit_price) }} {{
                                this.$store.state.UnitPrice }}
                        </span>
                    </div>

                    <div v-if="this.discountPrice != 0" class="d-flex justify-content-between mb-3">
                        <span class="summary-label">{{ $t("discount") }} ({{ discountPrice }} %)</span>
                        <span class="summary-label">
                            {{ (((this.discountPrice * this.PartialPrice) /
                                100) * this.$store.state.rate).toFixed($store.state.digit_price) }}
                            {{ this.$store.state.UnitPrice }}</span>
                    </div>


                    <div v-if="this.selectDeliveryType == 5" class="d-flex justify-content-between mb-3">
                        <span class="summary-label">{{ $t('Shipping') }}</span>
                        <span class="summary-label" v-if="deliveryPrice == 0">{{ $t('free') }}</span>
                        <span class="summary-label" v-else> {{
                            (deliveryPrice * this.$store.state.rate).toFixed($store.state.digit_price) }} {{
                                this.$store.state.UnitPrice }}</span>
                    </div>

                    <div v-if="$store.state.tax > 0" class="d-flex justify-content-between">
                        <span class="summary-total">{{ $t("tax") }} ( {{ $store.state.tax }}% ):</span>
                        <span class="summary-total">{{
                            (
                                ((this.$store.state.tax *
                                    (this.PartialPrice -
                                        (this.discountPrice * this.PartialPrice) / 100 +
                                        this.deliveryPrice)) /
                                    100) * this.$store.state.rate
                            ).toFixed($store.state.digit_price)
                        }}
                            {{ this.$store.state.UnitPrice }}</span>
                    </div>

                    <div class="d-flex justify-content-between">
                        <span class="summary-total">{{ $t("totalPrice") }}</span>
                        <span class="summary-total">
                            {{ (totalPrice * this.$store.state.rate).toFixed($store.state.digit_price) }} {{
                                this.$store.state.UnitPrice }}
                        </span>
                    </div>

                </div>
            </div>

              <div v-if="errorMessage" style="
  position: fixed;
  z-index: 100;
  width: 320px;
  top: 10%;
  left: 50px;
  border-radius: 8px;
  background-color: white;
  border: 2px solid var(--primary-color);
  text-align: center;
  padding: 10px;
  color: black;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
">

            <p style="margin-top: 10px;">{{ errorMessage }}</p>
        </div>
        </div>
      


</template>

<script>
import item_cart from "../components/cart_item_order.vue";
import { HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner } from "epic-spinners";

export default {
    components: {
        item_cart,
        HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner
    },
    data: function () {
        return {
            loading_coupon:false,
            errorMessage: null,
            loading: true,
            user_name: null,
            phone: null,
            email: null,
            items: [],
            password: null,
            products: [],
            products_cost: [],
            loadingMethods: false,
            addresses: [],
            addAddress: false,
            showAddress: false,
            showMonthes: false,
            DBitems: null,
            discount_delivery_free: 0,
            selectPaymentType: null,
            selectDeliveryType: null,
            selectAddress: null,
            count_month: null,
            disCode: null,
            discount_id: null,
            PartialPrice: 0,
            discountPrice: 0,
            deliveryPrice: 0,
            totalPrice: 0,
            couponMsg: "",
            unit: this.$store.state.unit,
            allOrderNote: "",
            langChange: "",
            cities: [],
            regions: [],
            countries: [],
            country: 6,
            city: null,
            region: null,
            street: null,
            building: null,
            street: null,
            other_details: null,
            show_guest: false,
            show_password: false,
            loading_confirm: false,
        };
    },
    created() {
        this.$store.state.showHeader = false;
        this.$store.state.showFooter = false;
        if (this.$i18n.locale == 'ar') {
            this.unit = this.$store.state.unitAR;
        }
        else {
            this.unit = this.$store.state.unit;
        }

        //
        let AllCookies = this.$cookies.keys();
        this.items = [];
        this.products = [];
        this.products_cost = [];
        for (let i = 0; i < AllCookies.length; i++) {
            if (AllCookies[i].split("/")[0] == this.$store.storeName) {
                console.log('$$$$$$ ')

                this.items.push(AllCookies[i]);
                this.products.push(this.$cookies.get(AllCookies[i]));
                ////PartialPrice
                if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
                    this.PartialPrice += this.$cookies.get(AllCookies[i]).offer_price;

                    console.log('$$$$$$ offer price ', i, '  ', this.PartialPrice)
                } else {

                    this.PartialPrice += this.$cookies.get(AllCookies[i]).total_price;
                    console.log('$$$$$$  total_price ', i, ' ', this.PartialPrice)
                }
                // console.log('products',pluck(this.products,"product_id"));
            }
        }
        for (let i = 0; i < this.products.length; i++) {
            this.products_cost.push(this.products[i]['product_id']);
        }
        console.log('product_cost: ', this.products_cost);

        this.loading = false;
        this.loadingMethods = true;
        if (this.products_cost.length != 0) {
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/order/create/v2",
                    {
                        products: this.products_cost,
                    },
                    {

                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.DBitems = response.data.data;
                })
                .then((this.loadingMethods = false))
                .catch((error) => {
                    if (error.response.status == "401") {

                    }
                });

        }

        this.axios
            .get(
                this.$store.state.base_api_url +
                this.$store.storeName +
                "/guest/addresses/create",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                    },
                }
            )
            .then((response) => {
                this.cities = response.data.data.cities;
                this.countries = response.data.data.countries;

            }).then();

    },
    watch: {
        langChange() {
            //  this.loading = false;
            if (this.$i18n.locale == 'ar') {
                this.unit = this.$store.state.unitAR;
            }
            else {
                this.unit = this.$store.state.unit;
            }
            //get profile

            //
            let AllCookies = this.$cookies.keys();
            this.items = [];
            this.products = [];
            this.products_cost = [];
            this.PartialPrice = 0;
            for (let i = 0; i < AllCookies.length; i++) {
                if (AllCookies[i].split("/")[0] == this.$store.storeName) {
                    this.items.push(AllCookies[i]);
                    this.products.push(this.$cookies.get(AllCookies[i]));
                    ////PartialPrice
                    if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
                        this.PartialPrice += this.$cookies.get(AllCookies[i]).offer_price;
                    } else {
                        this.PartialPrice += this.$cookies.get(AllCookies[i]).total_price;
                    }
                    // console.log('products',pluck(this.products,"product_id"));
                }
            }

            for (let i = 0; i < this.products.length; i++) {
                this.products_cost.push(this.products[i]['product_id']);
            }
            console.log('product_cost: ', this.products_cost);
            this.loading = false;


            ///////////methods
            this.loadingMethods = true;
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/order/create/v2",
                    { products: this.product_cost },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.DBitems = response.data.data;
                    // console.log(this.addresses);
                })
                .then((this.loadingMethods = false))
                .catch((error) => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/";
                    }
                });


            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/addresses/create",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.cities = response.data.data.cities;
                }).then(this.loading = false);
        }
        ,
        PartialPrice() {
            //$store.state.tax
            //console.log("this.$store.state.tax "+ this.$store.state.tax + "  " +this.$store.state.tax+  this.PartialPrice)
            let x =
                this.PartialPrice -
                (this.discountPrice * this.PartialPrice) / 100 +
                this.deliveryPrice;
            this.totalPrice = x + (this.$store.state.tax * x) / 100;
            /*  let x= this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 );
                  this.totalPrice = x + ( (this.$store.state.tax *  x) / 100 ) +this.deliveryPrice;*/
            /* this.totalPrice =
                     this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
                   console.log("PartialPrice Change" + this.totalPrice);*/
        },
        discountPrice() {
            let x =
                this.PartialPrice -
                (this.discountPrice * this.PartialPrice) / 100 +
                this.deliveryPrice;
            this.totalPrice = x + (this.$store.state.tax * x) / 100;
            /* this.totalPrice =
                   this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
                   console.log("discountPrice Change" + this.totalPrice);*/
        },
        deliveryPrice() {
            let x =
                this.PartialPrice -
                (this.discountPrice * this.PartialPrice) / 100 +
                this.deliveryPrice;
            this.totalPrice = x + (this.$store.state.tax * x) / 100;
            /*  this.totalPrice =
                    this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
                    console.log("deliveryPrice Change" + this.totalPrice);*/
        },
        selectDeliveryType() {
            if (this.selectDeliveryType == 5) {
                this.showAddress = true;
                document.getElementById('delivery_method5').classList.add('active');
                document.getElementById('delivery_method4').classList.remove('active');

                //console.log("this.showAddress" + this.showAddress);
            } else {
                this.showAddress = false;
                document.getElementById('delivery_method4').classList.add('active');
                document.getElementById('delivery_method5').classList.remove('active');

            }
        },
        selectPaymentType() {
            if (this.selectPaymentType == 4) {
                this.showMonthes = true;
            } else {
                this.showMonthes = false;
                this.count_month = null;
            }
            //console.log( this.count_month)
        },
        country(newVal) {
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/addresses/cities/" +
                    this.country,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.cities = response.data.data.cities;
                    if (this.cities.find((o) => o.id == this.cities) == null) {
                        this.city = null;
                    }
                });
        },
        city(newVal) {
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/addresses/regions/" +
                    this.city,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.regions = response.data.data.regions;
                    if (this.regions.find((o) => o.id == this.region) == null) {
                        this.region = null;
                    }
                });
        },

        region(newVal) {
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/cost_delivery",
                    {
                        region_id: newVal,
                        delivery_id: 5,
                        cost: this.PartialPrice,
                        products: this.products_cost,
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    if (response.data.code == "1") {
                        if (this.discount_delivery_free == 0) {
                            // console.log(this.discount_delivery_free);
                            this.deliveryPrice = response.data.data.cost;
                        }
                        this.selectDeliveryType = 5// id;
                        //console.log(this.selectDeliveryType);
                        for (
                            let el = 0;
                            el < this.DBitems.delivery_type.types.length;
                            el++
                        ) {
                            this.DBitems.delivery_type.types[el].isActive = false;
                            if (this.DBitems.delivery_type.types[el].id == 5) {
                                this.DBitems.delivery_type.types[el].isActive = true;
                            }
                            //console.log(this.DBitems.delivery_type.types[el].isActive);
                        }
                        // this.discountPrice = response.data.data.discount;
                    } else {
                        this.errorMessage = (response.data.message);
                        setTimeout(() => {
                            this.errorMessage = "";
                            this.count_error = 0;
                        }, 3000);
                        this.selectAddress = null;

                        // const $select = document.querySelector("#addressSelect");
                        //$select.value = "SelectOne";
                    }
                    //this.addresses = response.data.data.addresses.addresses;
                    // console.log(this.addresses);
                })
                .then(() => {
                    this.loadingMethods = false;
                })
                .catch((error) => {
                    if (error.response.status == "401") {
                        //  this.$localStorage.remove(this.$store.storeName);
                        // window.location.href =
                        //   "/";
                    }
                });
        },

    },
    methods: {
        funshow_guest() {
            if (this.show_guest == false)
                this.show_guest = true;
            else
                this.show_guest = false;

        },
        close_address() {
            this.$store.state.addAddress = false;
        },
        open_address() {
            this.$store.state.addAddress = true;
        },
        updatAddress() {
            ///////////addresses
            this.loading = true;
            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/addresses",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.addresses = response.data.data.addresses.addresses;
                    /*if (this.addresses.length != 0) {
                      this.selectAddress = this.addresses[0].id;
                    }*/
                    // console.log(this.addresses);
                })
                .then((this.loading = false))
                .catch((error) => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href =
                            "/";
                    }
                });
        },
        updatedata2() {
            console.log('jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj')
            this.langChange_check = false;
            this.langChange = false;
            ///////////methods
            this.loadingMethods = true;
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/order/create/v2",
                    { products: this.product_cost },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.DBitems = response.data.data;
                    // console.log(this.addresses);
                })
                .then((this.loadingMethods = false))
                .catch((error) => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/";
                    }
                });


            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/addresses/create",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.cities = response.data.data.cities;
                }).then(this.loading = false);

        },
        Couponcode() {
            this.loading_coupon = true;
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/use_coupon",
                    {
                        code: this.disCode,
                        total_price: this.PartialPrice,
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.loading_coupon=false;
                    if (response.data.code == "1") {
                        this.couponMsg = "";
                        this.discountPrice = response.data.data.discount;
                        this.discount_id = response.data.data.discount_id;
                        this.discount_delivery_free = response.data.data.isdelivery_free;
                        if (this.discount_delivery_free == 1)
                            this.deliveryPrice = 0;
                        /////////for select
                        // this.selectAddress = null;
                        // this.deliveryPrice = 0;
                        ////////////
                    } else {
                        this.couponMsg = response.data.message;
                        /////////for select
                        // this.selectAddress = null;
                        // this.deliveryPrice = 0;
                        ////////////
                    }
                    //this.addresses = response.data.data.addresses.addresses;
                    // console.log(this.addresses);
                })
                .then((this.loading = false))
                .catch((error) => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href =
                            "/";
                    }
                });
        },
        selectPaymentTypeId(id) {
            document.getElementById('payment').style = "color:black";
            this.loadingMethods = true;
            this.selectPaymentType = id;
            //console.log(this.selectPaymentType);

            for (let el = 0; el < this.DBitems.payment_types.types.length; el++) {
                this.DBitems.payment_types.types[el].isActive = false;
                if (this.DBitems.payment_types.types[el].id == id) {
                    this.DBitems.payment_types.types[el].isActive = true;
                }
                //console.log(this.DBitems.payment_types.types[el].isActive);
            }

            //setTimeout(() => {
            this.loadingMethods = false;
            //  }, 3000);
        },
        selectDeliveryTypeId(id) {
            //  this.loadingMethods = true;
            console.log("bbbbbbbbbbbbbbbbbbb");
            this.selectDeliveryType = id;
            document.getElementById('delivery').style = "color:black";
            for (
                let el = 0;
                el < this.DBitems.delivery_type.types.length;
                el++
            ) {
                this.DBitems.delivery_type.types[el].isActive = false;
                if (this.DBitems.delivery_type.types[el].id == id) {
                    this.DBitems.delivery_type.types[el].isActive = true;
                }
                //console.log(this.DBitems.delivery_type.types[el].isActive);
            }
        },

        onChange: function (event) {
            this.selectAddress = event.target.value;
            this.selectDeliveryTypeId(5);
        },
        onChangeMonths: function (event) {
            //console.log( event.target.value)
            this.count_month = event.target.value;
        },
        confirmOrder() {
            this.change_state();
            document.getElementById("confirm_btn").disabled = true;
            this.loading_confirm = true;
            var count_error = 0;
            var error_msg = "";

            if (this.selectPaymentType == null) {
                count_error++;
                document.getElementById('payment').style = 'color:red'

                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب تحديد طريقة الدفع");
                } else {
                    error_msg += ("Please select a payment type ");
                }
            }

            if (this.user_name == null) {
                count_error++;
                document.getElementById('name').style = 'border:2px solid red !important'

                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب ادخال الاسم");
                } else {
                    error_msg += (" Please Enter Name");
                }
            }

            if (this.selectDeliveryType == null) {
                document.getElementById('delivery').style = 'color:red'

                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب تحديد طريقة التوصيل");
                } else {
                    error_msg += (" Please select a delivery type");
                }
            }

            if (this.selectDeliveryType == 5 && this.region == null) {
                document.getElementById('region').style = 'border:2px solid red !important'

                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += ("يجب اختيار المنطقة ");
                } else {
                    error_msg += (" Please Select A Region");
                }
            }



            if (this.phone == null) {
                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب ادخال الهاتف");
                } else {
                    error_msg += (" Please Enter Phone");
                }
                document.getElementById('phone').style = 'border:2px solid red !important;text-align:center'
            }
            if (count_error == 0) {
                this.loading_confirm = false;
                this.axios
                    .post(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/order/store/v2",
                        {

                            delivery_type_id: this.selectDeliveryType,
                            payment_type_id: this.selectPaymentType,
                            total_price: this.totalPrice,
                            discount_id: this.discount_id,
                            products: this.products,
                            part_price: this.PartialPrice,
                            note: this.allOrderNote,
                            count_month: this.count_month,
                            device: 'web',
                            user_name: this.user_name,
                            phone: this.phone,
                            email: this.email,
                            region_id: this.region,
                            street: this.street,
                            building: this.building,
                            other_details: this.other_details

                        },
                        {
                            headers: {
                                "Accept-Language": this.$i18n.locale,
                                Authorization:
                                    "Bearer " + this.$localStorage.get(this.$store.storeName),
                            },
                        }
                    )
                    .then((response) => {
                        this.loading_confirm = false;

                        if (response.data.code == "1") {
                            if (response.data.data.clear_cart == null || response.data.data.link_pay == null) {
                                for (let i = 0; i < this.items.length; i++) {
                                    this.$cookies.remove(this.items[i]);
                                }
                                this.items = [];

                                console.log("hiiiiiiii" + this.$cookies.keys());
                                this.$store.state.cartCounter = 0;
                            }

                            //console.log("hiiiiiiii" + this.$cookies.keys());

                            if (response.data.data.link_pay == null) {
                                this.$store.state.cartCounter = 0;
                                this.$router.push({
                                    name: "order_done",
                                    params: {
                                        storeName: this.$store.storeName,
                                        lang: this.$i18n.locale,
                                        id: response.data.data.order_id
                                    },
                                });
                            }

                            if (response.data.data.link_pay != null) {
                                window.location.href = response.data.data.link_pay;
                            }

                            //this.deliveryPrice = response.data.data.cost;
                            // this.discountPrice = response.data.data.discount;
                        } else {
                            this.errorMessage = error_msg;
                            setTimeout(() => {
                                this.errorMessage = "";
                                this.count_error = 0;
                            }, 3000);
                            document.getElementById("confirm_btn").disabled = false;
                            var count_error = 0;
                            var error_msg = "";
                            // this.couponMsg = response.data.message;
                        }
                        //this.addresses = response.data.data.addresses.addresses;
                        // console.log(this.addresses);
                    })
                    .then((this.loading = false))
                    .catch((error) => {
                        if (error.response.status == "401") {
                            this.$localStorage.remove(this.$store.storeName);
                            // window.location.href =
                            //   "/"+this.$i18n.locale ;
                        }
                    });
            }
            else {
                this.loading_confirm = false;
                this.errorMessage = error_msg;
                setTimeout(() => {
                    this.errorMessage = "";
                    this.count_error = 0;
                }, 3000); document.getElementById("confirm_btn").disabled = false;

            }


            //////////

            //////////

        },
        change_state() {
            document.getElementById('payment').style = "color:black";
            document.getElementById('delivery').style = "color:black";
            if (document.getElementById('region'))
                document.getElementById('region').style = "border: 0px solid var(--primary-color) !important;";
            document.getElementById('phone').style = "border: 0px solid var(--primary-color) !important;";
            document.getElementById('name').style = "border: 0px solid var(--primary-color) !important;";

        },
        funcreate_account_email() {
            console.log('11111111111')

            if (document.getElementById('account_email').checked == true)
                this.show_password = true;
            else
                this.show_password = false;
        },

        create_account() {

            var count_error = 0;
            var error_msg = "";
            document.getElementById('phone').style = "border: 0px solid #dde2e6 !important;";
            document.getElementById('name').style = "border: 0px solid #dde2e6 !important;";
            document.getElementById('email').style = "border: 0px solid #dde2e6 !important;";
            document.getElementById('password').style = "border: 0px solid #dde2e6 !important;";

            if (this.phone == null) {
                count_error++;
                document.getElementById('phone').style = 'border:2px solid red !important'


                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب إدخال الرقم");
                } else {
                    error_msg += ("Please Add Phone ");
                }
            }


            if (this.user_name == null) {
                count_error++;
                document.getElementById('name').style = 'border:2px solid red !important'


                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب إدخال الاسم");
                } else {
                    error_msg += ("Please Add User Name ");
                }
            }

            if (this.password == null) {
                count_error++;
                document.getElementById('password').style = 'border:2px solid red !important'


                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب إدخال كلمة السر");
                } else {
                    error_msg += ("Please Enter Password ");
                }
            }

            if (this.email == null) {
                count_error++;
                document.getElementById('email').style = 'border:2px solid red !important'


                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب إدخال الايميل");
                } else {
                    error_msg += ("Please Add Email");
                }
            }
            if (count_error == 0) {
                this.loading = true;
                console.log(this.phone)

                this.axios
                    .post(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/register",
                        {
                            phone: this.$store.state.country_code + this.phone,
                            name: this.user_name,
                            email: this.email,
                            password: this.password

                        },

                        {

                            headers: {
                                "Accept-Language": this.$i18n.locale,
                            },
                        }
                    )
                    .then((response) => {
                        this.loading = false;

                        if (response.data.code == "1") {

                            this.$localStorage.set(
                                this.$store.storeName,
                                response.data.data.token
                            );
                            this.$localStorage.set(
                                this.$store.user_name,
                                response.data.data.name
                            );
                            if (!response.data.data.name || response.data.data.name == '') {
                                this.$localStorage.set(
                                    this.$store.user_name,
                                );
                            }
                            console.log(
                                this.$localStorage.get(this.$store.storeName) +
                                " id : " +
                                this.$store.storeName
                            );

                            console.log(
                                "user token : " +
                                this.$localStorage.get(this.$store.storeName)
                            );

                            window.location.href = '/checkout';
                            this.loading = false;
                        } else if (response.data.code == "-1") {
                            this.loading = false;
                            this.errorMessage = response.data.message;
                            setTimeout(() => {
                                this.errorMessage = "";
                                this.count_error = 0;
                            }, 3000);
                        }
                        if (response.data.error) {
                            this.errorMessage = "response.data.error";
                            setTimeout(() => {
                                this.errorMessage = "";
                            }, 3000);
                        }

                    });
            }
            else {
                alert(error_msg);
                setTimeout(() => {

                    var count_error = 0;
                    var error_msg = "";
                    document.getElementById('phone').style = "border: 0px solid #dde2e6 !important;";
                    document.getElementById('name').style = "border: 0px solid #dde2e6 !important;";
                    document.getElementById('email').style = "border: 0px solid #dde2e6 !important;";
                    document.getElementById('password').style = "border: 0px solid #dde2e6 !important;";
                }, 8000);
            }




        }
    },
};

</script>